export interface DashboardStats {
  title: string;
  value: number;
  change: number;
  changeLabel: string;
  icon: string;
  iconColor: string;
  iconBg: string;
}

export const dashboardStats: DashboardStats[] = [
  {
    title: "今日发放眼镜数",
    value: 384,
    change: 12.5,
    changeLabel: "较昨日",
    icon: "ri-glasses-line",
    iconColor: "text-teal-600",
    iconBg: "bg-teal-50",
  },
  {
    title: "在线眼镜数",
    value: 312,
    change: -2.3,
    changeLabel: "较昨日",
    icon: "ri-wifi-line",
    iconColor: "text-emerald-600",
    iconBg: "bg-emerald-50",
  },
  {
    title: "今日 AI 问答次数",
    value: 2647,
    change: 28.6,
    changeLabel: "较昨日",
    icon: "ri-chat-3-line",
    iconColor: "text-amber-600",
    iconBg: "bg-amber-50",
  },
  {
    title: "今日换脸生成数",
    value: 156,
    change: 45.2,
    changeLabel: "较昨日",
    icon: "ri-image-line",
    iconColor: "text-rose-600",
    iconBg: "bg-rose-50",
  },
];

export interface HeatmapData {
  name: string;
  triggers: number;
}

export const heatmapData: HeatmapData[] = [
  { name: "西陵峡口", triggers: 428 },
  { name: "三峡大坝", triggers: 892 },
  { name: "葛洲坝", triggers: 567 },
  { name: "黄牛岩", triggers: 234 },
  { name: "石牌要塞", triggers: 345 },
  { name: "三游洞", triggers: 189 },
  { name: "南津关", triggers: 156 },
  { name: "屈原故里", triggers: 278 },
  { name: "秭归港", triggers: 123 },
  { name: "太平溪", triggers: 98 },
];

export interface DeviceStatus {
  name: string;
  value: number;
  color: string;
}

export const deviceStatusData: DeviceStatus[] = [
  { name: "在线", value: 312, color: "#10b981" },
  { name: "离线", value: 89, color: "#9ca3af" },
  { name: "低电", value: 23, color: "#ef4444" },
  { name: "维护中", value: 12, color: "#8b5cf6" },
];

export interface ActivityItem {
  id: string;
  type: "pair" | "question" | "faceswap" | "report" | "device";
  content: string;
  time: string;
  timeLabel: string;
}

export const activityList: ActivityItem[] = [
  {
    id: "1",
    type: "pair",
    content: "眼镜 #A102 已配对，绑定游客 陈明远",
    time: "2026-06-01 14:32:18",
    timeLabel: "2 分钟前",
  },
  {
    id: "2",
    type: "question",
    content: "游客提问『三峡大坝多高』，AI 已回答",
    time: "2026-06-01 14:28:45",
    timeLabel: "5 分钟前",
  },
  {
    id: "3",
    type: "faceswap",
    content: "换脸照已生成：游客李婷 - 三峡大坝合影模板",
    time: "2026-06-01 14:25:12",
    timeLabel: "9 分钟前",
  },
  {
    id: "4",
    type: "device",
    content: "眼镜 #A087 电量低于 20%，已推送换电提醒",
    time: "2026-06-01 14:18:33",
    timeLabel: "16 分钟前",
  },
  {
    id: "5",
    type: "question",
    content: "游客提问『葛洲坝什么时候建成的』，AI 已回答",
    time: "2026-06-01 14:15:07",
    timeLabel: "19 分钟前",
  },
  {
    id: "6",
    type: "pair",
    content: "眼镜 #A115 已配对，绑定游客 王建国",
    time: "2026-06-01 14:10:55",
    timeLabel: "23 分钟前",
  },
  {
    id: "7",
    type: "report",
    content: "行程报告已生成：船次 YC20260601-A，共 42 份",
    time: "2026-06-01 14:05:21",
    timeLabel: "28 分钟前",
  },
  {
    id: "8",
    type: "faceswap",
    content: "换脸照已生成：游客张伟 - 鲟侠船长造型模板",
    time: "2026-06-01 13:58:47",
    timeLabel: "35 分钟前",
  },
  {
    id: "9",
    type: "question",
    content: "游客提问『黄牛岩怎么形成的』，AI 已回答",
    time: "2026-06-01 13:52:10",
    timeLabel: "42 分钟前",
  },
  {
    id: "10",
    type: "device",
    content: "眼镜 #A063 离线超过 15 分钟，已标记异常",
    time: "2026-06-01 13:45:38",
    timeLabel: "49 分钟前",
  },
  {
    id: "11",
    type: "pair",
    content: "眼镜 #A098 已配对，绑定游客 刘芳",
    time: "2026-06-01 13:38:22",
    timeLabel: "56 分钟前",
  },
  {
    id: "12",
    type: "question",
    content: "游客提问『三游洞有什么历史典故』，AI 已回答",
    time: "2026-06-01 13:30:15",
    timeLabel: "1 小时前",
  },
];

export const quickActions = [
  {
    icon: "ri-link",
    title: "批量预配对",
    desc: "为下一船次眼镜提前生成配对码",
    color: "text-teal-600",
    bg: "bg-teal-50",
  },
  {
    icon: "ri-map-pin-add-line",
    title: "新增景点",
    desc: "在航线上添加新讲解触发点",
    color: "text-amber-600",
    bg: "bg-amber-50",
  },
  {
    icon: "ri-image-add-line",
    title: "上传换脸模板",
    desc: "上传新主题换脸模板供游客使用",
    color: "text-rose-600",
    bg: "bg-rose-50",
  },
  {
    icon: "ri-file-download-line",
    title: "导出今日报表",
    desc: "生成今日运营数据 Excel 报表",
    color: "text-emerald-600",
    bg: "bg-emerald-50",
  },
];

// ===== 实时游客 GPS 位置 =====
export interface VisitorGPSEntry {
  id: string;
  deviceId: string;
  visitor: string;
  area: string;
  lat: number;
  lng: number;
  bearing: number;
  speed: number;
  lastUpdate: string;
  online: boolean;
  trail: { lat: number; lng: number; timestamp: number }[];
}

/** 三峡沿线关键景点坐标 */
const scenicSpots = [
  { area: "三峡大坝",  centerLat: 30.823, centerLng: 111.020 },
  { area: "西陵峡口",  centerLat: 30.714, centerLng: 111.284 },
  { area: "葛洲坝",    centerLat: 30.733, centerLng: 111.274 },
  { area: "黄牛岩",    centerLat: 30.845, centerLng: 111.055 },
  { area: "石牌要塞",  centerLat: 30.784, centerLng: 111.123 },
  { area: "三游洞",    centerLat: 30.774, centerLng: 111.212 },
  { area: "南津关",    centerLat: 30.762, centerLng: 111.242 },
  { area: "屈原故里",  centerLat: 30.859, centerLng: 110.978 },
];

/** 生成初始游客 GPS 分布 — 每景点 2~4 人，附带历史轨迹 */
export function generateInitialVisitorGPS(): VisitorGPSEntry[] {
  const entries: VisitorGPSEntry[] = [];
  let seq = 0;
  const names = ["陈明远","王建国","李婷","张伟","刘芳","周杰","孙丽","吴敏","郑浩","黄静","谢雪","何伟","赵磊","杨洋","马超","戴玉","秦峰","罗兰","梁宇","宋雨"];

  scenicSpots.forEach((spot) => {
    const count = 2 + Math.floor(Math.random() * 3);
    for (let i = 0; i < count; i++) {
      const deviceNum = 100 + seq + 1;
      const startLat = spot.centerLat + (Math.random() - 0.5) * 0.008;
      const startLng = spot.centerLng + (Math.random() - 0.5) * 0.010;

      // 生成 20~40 个历史轨迹点，模拟过去 10 分钟的移动
      const trailLength = 20 + Math.floor(Math.random() * 20);
      const trail: { lat: number; lng: number; timestamp: number }[] = [];
      let curLat = startLat;
      let curLng = startLng;
      const now = Date.now();
      for (let t = trailLength - 1; t >= 0; t--) {
        curLat += (Math.random() - 0.5) * 0.0003;
        curLng += (Math.random() - 0.5) * 0.0004;
        trail.push({
          lat: curLat,
          lng: curLng,
          timestamp: now - (t + 1) * 30000,
        });
      }

      entries.push({
        id: `visitor-${spot.area}-${i}`,
        deviceId: `#A${deviceNum}`,
        visitor: names[seq % names.length],
        area: spot.area,
        lat: startLat,
        lng: startLng,
        bearing: Math.floor(Math.random() * 360),
        speed: Math.random() * 3 + 0.3,
        lastUpdate: "刚刚",
        online: Math.random() > 0.08,
        trail,
      });
      seq++;
    }
  });
  return entries;
}

/** 每次帧漂 — 模拟游客走动，同时追加轨迹点 */
export function driftGPS(entries: VisitorGPSEntry[]): VisitorGPSEntry[] {
  const now = Date.now();
  return entries.map((e) => {
    if (!e.online) return { ...e, lastUpdate: "离线" };
    const newLat = e.lat + (Math.random() - 0.5) * 0.0006;
    const newLng = e.lng + (Math.random() - 0.5) * 0.0008;
    const newTrail = [...e.trail, { lat: newLat, lng: newLng, timestamp: now }];
    // 保留最近 60 个点
    const trimmedTrail = newTrail.length > 60 ? newTrail.slice(newTrail.length - 60) : newTrail;
    return {
      ...e,
      lat: newLat,
      lng: newLng,
      bearing: (e.bearing + Math.floor(Math.random() * 15 - 7) + 360) % 360,
      speed: Math.max(0.1, e.speed + (Math.random() - 0.5) * 1.2),
      lastUpdate: "刚刚",
      trail: trimmedTrail,
    };
  });
}

export const scenicSpotsList = scenicSpots;